module.exports = __webpack_public_path__ + "static/media/sound2.55f23b72.mp3";